package com.essntl.features.itinerary.ui.all_itinerary

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.itinerary.ui.all_itinerary.components.AllItinerariesEmpty
import com.essntl.features.itinerary.ui.all_itinerary.components.AllItinerariesLoading
import com.essntl.features.itinerary.ui.all_itinerary.components.ItinerariesHeader
import com.essntl.features.itinerary.ui.all_itinerary.components.ItineraryListColumn
import com.essntl.features.itinerary.ui.rememberFilteredItineraries
import com.essntl.uikit.components.utils.spacing

@Composable
fun AllItineraryScreen(
    state: AllItineraryState,
    onEvent: (AllItineraryEvent) -> Unit,
    onNavigation: (AllItineraryNavigation) -> Unit,
) {
    val filteredItinerary = rememberFilteredItineraries(
        state.getAllItinerary.data,
        state.filterOptions,
    )

    Column(
        modifier = Modifier.fillMaxSize(),
    ) {
        ItinerariesHeader(
            state = state,
            onEvent = onEvent,
        )

        Spacer(modifier = Modifier.height(1.spacing))

        if (state.getAllItinerary.isLoading)
            AllItinerariesLoading()
        else if (filteredItinerary.isEmpty())
            AllItinerariesEmpty()
        else
            ItineraryListColumn(
                state = state,
                onNavigation = onNavigation,
                itineraryList = filteredItinerary,
            )
    }
}